export const ROUTES = {
  HOME: '/',
  ABOUT_US: '/about',
  CONTACT: '/contact',
  SERVICES: '/services',
  PROJECTS: '/projects'
};